import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'

export default {
    data () {
        return {
            dateStart: this.dateFormatDMY2(new Date()),
            dateEnd: this.dateFormatDMY2(new Date()),
            data_receive: '',
            data_list: [],
            header: {
                headers: {
                    'access-token': this.$store.state.token
                }
            }
        }
    },
    methods: {
        getCancelReceive () {
            this.$store.state.isLoading = true
            api.getCancelReceive(
                {
                    'date_start': this.dateStart,
                    'date_end': this.dateEnd,
                    'active_page': 1,
                    'per_page': 100000000
                },
                this.header,
                result => {
                    if (result.response === true) {
                        this.$store.state.isLoading = false
                        this.data_receive = JSON.stringify(result.data.pagination)
                        this.data_list = result.data.pagination
                    } else {
                        Swal.fire('ดึงข้อมูลรายงาน', result.message, 'warning')
                        this.$store.state.isLoading = false
                    }
                },
                error => {
                    alert(JSON.stringify(error))
                    this.$store.state.isLoading = false
                }
            )
        }
    },
    mounted () {
        this.getCancelReceive()
        $('input').on ('change', function () {
            this.setAttribute(
                'data-date',
                moment(this.value, 'YYYY-MM-DD')
                    .format(this.getAttribute('data-date-format'))
            )
        }).trigger('change')
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/report_cancel_receive.js